// extracted by mini-css-extract-plugin
module.exports = {"dl":"TxDetails_dl__1UVni"};